import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSections = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5 1H18V3H5V1ZM1.5 3.5C0.67157 3.5 0 2.82843 0 2C0 1.17157 0.67157 0.5 1.5 0.5C2.32843 0.5 3 1.17157 3 2C3 2.82843 2.32843 3.5 1.5 3.5ZM1.5 10.5C0.67157 10.5 0 9.8284 0 9C0 8.1716 0.67157 7.5 1.5 7.5C2.32843 7.5 3 8.1716 3 9C3 9.8284 2.32843 10.5 1.5 10.5ZM1.5 17.4C0.67157 17.4 0 16.7284 0 15.9C0 15.0716 0.67157 14.4 1.5 14.4C2.32843 14.4 3 15.0716 3 15.9C3 16.7284 2.32843 17.4 1.5 17.4ZM5 8H18V10H5V8ZM5 15H18V17H5V15Z",
		fill: "currentColor"
	})
});
export default SvgSections;
